import { getSmallContainer } from '@platform-ui/icon';
const svgContent = '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" focusable="false"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.5 8 6.658 2 5.316 3.423 9.816 8l-4.5 4.577L6.658 14 12.5 8Z" fill="currentColor"/></svg>';
export const TuiIconTdsSmallPragmaticChevronRight = /*#__PURE__*/ getSmallContainer(svgContent);
